import { render, staticRenderFns } from "./UpdateCurrencyPayment.vue?vue&type=template&id=6507fdd9"
import script from "./UpdateCurrencyPayment.vue?vue&type=script&lang=js"
export * from "./UpdateCurrencyPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports